import React, { useState } from "react";
import { adjustStudentPointsAPI } from "../../../reward/rewardAPI";

const POINT_ADD_COLOR = "#16A34A";
const POINT_SUBTRACT_COLOR = "#E5383B";

// 재원생 관리 표의 포인트 칸(2026-10-07 대표 시안). 칸에 포인트와 사유를 바로 쓰고 추가(초록) · 감소(빨강).
// 사유는 아이 포인트 내역에 그대로 보인다. 서버: api/reward/views.py TeacherStudentPointViewSet
const StudentPointCell = ({ student, balance, onSaved }) => {
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  // 저장한 뒤 잠깐 '+100' 을 띄운다
  const [flash, setFlash] = useState(null);

  const save = async (sign) => {
    const value = parseInt(amount, 10);
    if (!value) return alert("포인트를 적어 주세요.");
    if (!reason.trim()) return alert("사유를 적어 주세요.");
    setIsSaving(true);
    try {
      const result = await adjustStudentPointsAPI(student.id, sign * value, reason.trim());
      onSaved(result.balance);
      setAmount("");
      setReason("");
      setFlash(sign * value);
      window.setTimeout(() => setFlash(null), 1600);
    } catch (error) {
      alert(error?.response?.data?.error || "저장하지 못했습니다.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
      <span className="cell-numeric" style={{ minWidth: "64px", textAlign: "right", fontWeight: 800, whiteSpace: "nowrap" }}>
        {balance.toLocaleString()}P
        {flash !== null && (
          <span style={{ marginLeft: "4px", fontSize: "12px", color: flash > 0 ? POINT_ADD_COLOR : POINT_SUBTRACT_COLOR }}>
            {flash > 0 ? "+" : ""}
            {flash.toLocaleString()}
          </span>
        )}
      </span>
      <div style={{ position: "relative", width: "60px", flex: "none" }}>
        <input
          inputMode="numeric"
          placeholder="0"
          value={amount}
          onChange={(event) => setAmount(event.target.value.replace(/[^0-9]/g, ""))}
          style={{ ...inputStyle, width: "100%", paddingRight: "24px", textAlign: "right", fontWeight: 700 }}
        />
        <span style={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)", color: "#9AA3AB", fontSize: "12px" }}>
          P
        </span>
      </div>
      <input
        placeholder="사유"
        maxLength={100}
        value={reason}
        onChange={(event) => setReason(event.target.value)}
        style={{ ...inputStyle, flex: "1 1 0", minWidth: "48px", width: 0 }}
      />
      <button type="button" disabled={isSaving} onClick={() => save(1)} style={{ ...buttonStyle, background: POINT_ADD_COLOR }}>
        추가
      </button>
      <button type="button" disabled={isSaving} onClick={() => save(-1)} style={{ ...buttonStyle, background: POINT_SUBTRACT_COLOR }}>
        감소
      </button>
    </div>
  );
};

const inputStyle = {
  boxSizing: "border-box", height: "32px", border: "1px solid #D9E3E2", borderRadius: "8px", padding: "0 10px",
  fontFamily: "inherit", fontSize: "13px", outline: "none", background: "#fff",
};
const buttonStyle = {
  flex: "none", height: "32px", border: "none", borderRadius: "8px", padding: "0 9px", color: "#fff", whiteSpace: "nowrap",
  fontFamily: "inherit", fontWeight: 800, fontSize: "13px", cursor: "pointer",
};

export default StudentPointCell;
